import { LANGUAGE_SELECT_OPTIONS } from '../../languages/constants'
import { Language } from '../../languages/types'

type Option = { label: string; value: Language }

export function getLanguageOptions (langList: Language[]): Option[] {
  const languageSelectOptions = LANGUAGE_SELECT_OPTIONS.filter((lang) =>
    langList.includes(lang.value as Language),
  ) as Option[]
  return languageSelectOptions
}
